<div class="container-fluid">
    <div class="row">
      <div
        class="col-12 col-sm-5 d-none d-sm-flex flex-column min-full-height justify-content-between left-panel position-relative"
      >
        <img
          src="../../../assets/images/Logo-colorido.png"
          alt="Logo"
          class="logo"
        />
        <p class="bottom-text">
          Avoid The Headache, Get a Simple Solution That Meets Your Needs
        </p>
      </div>
      <div class="col-12 d-sm-none pt-5 px-4">
        <img
          src="../../../assets/images/Logo-colorido.png"
          alt="Logo"
          class="logo"
        />
      </div>
      <div class="col-12 col-sm-7">
        <div class="right-panel">
          <form (ngSubmit)="onSubmit()" class="login-form">
            <p class="title">Forgot password?</p>
            <div class="form-group">
              <label>Enter the email address you used when you joined and we’ll send you instructions to reset your password.</label>
            </div>
            <div class="form-group">
              <label for="email" class="input-label">Email</label>
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">
                  <i class="bi bi-envelope"></i>
                </span>
                <input
                  type="email"
                  class="form-control input-label"
                  [(ngModel)]="usrEmail"
                  (input)="checkFields()"
                  name="email"
                />
              </div>
            </div>

            <div class="form-group div-Forgot">
              <a [routerLink]="['/login']" class="forgot-password" (click)="returnToLogin()">Sign in</a>
            </div>
  
            <div class="form-group">
              <button
                type="submit"
                class="sign-in-button btn btn-primary"
                [disabled]="!fieldsCompleted"
              >
                Send recovery code
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  